<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SetMarginReminder')"
    width="380px"
    :close-on-click-modal="false"
  >
    <div style="display: flex;height: 80px;align-items: center;padding-left: 20px;">
      <el-form :inline="true" class="inline-form" label-width="120px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_NumberOfCompanyReminders')">
          <el-input-number v-model="remindMargin" no="remindMargin" :min="0" :max="999" controls-position="right" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="confirmSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { getOfficeById, modifyMawbRemindMargin } from '@/api/office'

export default {
  name: 'MarginReminderDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    officeId: { type: Number, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      remindMargin: 0
    }
  },
  computed: {
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      getOfficeById(this.officeId).then(res => { this.remindMargin = res.data.remindMargin })
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    confirmSave() {
      modifyMawbRemindMargin({ officeId: this.officeId, remindMargin: this.remindMargin }).then(res => {
        if (res.ok && res.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }
      })
      this.innerVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
